import React from 'react';
import ConfirmModal from '../UI/Modal/confirmModal';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeleteWorkspaceModal = ({ hideModal, handleConfirmation, loading }) => {
    const { content } = useContentfulContext();

  return (
    <ConfirmModal
        title={content.WORKSPACE_MANAGEMENT_CONTENT.modal.delete_title}
        description={content.WORKSPACE_MANAGEMENT_CONTENT.modal.delete_title}
        ConfirmText={content.WORKSPACE_MANAGEMENT_CONTENT.modal.delete_btn}
        loading={loading}
        hideModal={hideModal}
        handleConfirmation={handleConfirmation}
    />
  )
}

export default DeleteWorkspaceModal;